import { createFileRoute, Outlet } from "@tanstack/react-router";
import { getConciergeDisplayName } from "@/lib/i18n";

export const Route = createFileRoute("/concierge")({
  head: () => ({
    meta: [
      { title: `${getConciergeDisplayName("pt")} — Routify` },
      {
        name: "description",
        content:
          "A equipa Routify planeia a tua viagem à medida: destinos, datas, orçamento e interesses.",
      },
      { property: "og:title", content: `${getConciergeDisplayName("pt")} — Routify` },
      {
        property: "og:description",
        content: "Um roteiro feito à mão pela nossa equipa, adaptado ao teu perfil.",
      },
    ],
  }),
  component: () => <Outlet />,
});
